

TagIndexController = ($state, $http, ApiUrl) ->
    'ngInject'

    vm = @

    @showForm = false
    @searchText = null

    @loading = true
    @programSpecific = @program?
    @editableTypes = []

    loadTags = tagLoader($http, ApiUrl, @program)

    @setTagFor = (tagFor) ->
        vm.tagFor = tagFor
        vm.refresh()
        vm.editableTypes = []
        for type in tagFor.types
            vm.editableTypes.push type if type.editable
        return

    @refresh = ->
        params =
            q: vm.searchText
            tag_for: vm.tagFor.name
            program_id: vm.program?.id

        return loadTags(params)
            .then (data) ->
                vm.tags = data.items
                vm.counts = data.counts
                return

    @tagCreated = (tag) ->
        $state.go('^.view', {tagId: tag.id})
        return tag

    getTagTypes($http, ApiUrl, @program)
        .then (tagTypes) ->
            vm.tagTypes = tagTypes
            vm.setTagFor(tagTypes[0])
            return vm.refresh()

    return


tagLoader = ($http, ApiUrl, program) ->
    return (params) ->
        url = ApiUrl('tag')
        return $http.get(url, params: params)
            .then (r) -> r.data

getTagTypes = ($http, ApiUrl, program) ->
    url = ApiUrl('tag', 'types')
    params = program_id: program?.id
    return $http.get(url, params: params)
        .then (r) -> r.data.items

assign = (obj, name) ->
    (value) ->
        obj[name] = value
        console.log obj
        return value

tagIndexComponent =
    controller: TagIndexController
    controllerAs: 'tagIndex'
    templateUrl: 'tags/index'
    bindings: program: '='

module.component 'tagIndex', tagIndexComponent
